import { render } from "./MyLikes.vue?vue&type=template&id=3ca46ad9&ts=true"
import script from "./MyLikes.vue?vue&type=script&lang=ts"
export * from "./MyLikes.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__